// @flow

import React from 'react'
import { useTranslation } from 'react-i18next'

import { Container, Prompt, ArrowsIcon, LeftArrowIcon, RightArrowIcon } from './Helper.styles'

export const Helper = () => {
  const { t } = useTranslation()

  return (
    <Container>
      <Prompt>{t('hold_for_options_ok')}</Prompt>
      <Prompt>{t('ok_play_channel')}</Prompt>
      <Prompt>
        <ArrowsIcon /> {t('select_channel')}
      </Prompt>
      <Prompt>
        <LeftArrowIcon />
        {t('go_to_all_lists')}
      </Prompt>
      <Prompt>
        <RightArrowIcon />
        {t('close_list')}
      </Prompt>
    </Container>
  )
}
